import * as Factory from 'factory.ts'
import * as faker from 'faker'

import { type ApproverCounts } from '@webapp/models/ApproverCounts'

export const ApproverCountsMock = Factory.Sync.makeFactory<ApproverCounts>({
  approval_history: faker.random.number(),
  pending: faker.random.number(),
})
